<template>
    <div class="index">
        <!-- 联盟动态 -->
        <div class="alliance">
            <div class="alliance_box section">
                <div class="alliance_top">
                    <div class="common_title">
                        <div class="common_title_top">
                            <div class="common_title_top_left"></div>
                            <div class="common_title_top_middle">联盟动态</div>
                            <div class="common_title_top_right"></div>
                        </div>
                        <div class="common_title_bottom">ALLIANCE NEWS</div>
                    </div>
                </div>
                <div class="alliance_bottom" v-if="alliance.length>0">
                    <div class="alliance_bottom_left" @click="handleAlliance(alliance[allianceIndex])">
                        <div class="alliance_bottom_left_img">
                            <img v-if="alliance[allianceIndex]&&alliance[allianceIndex].picture" :src="baseUrl+alliance[allianceIndex].picture" alt="">
                            <img class="none_img" v-else src="../assets/images/index/img_none.png" alt="">
                        </div>
                        <div class="alliance_bottom_left_profile">
                            <div class="alliance_bottom_left_profile_text" v-if="alliance[allianceIndex]">
                                {{alliance[allianceIndex].profile}}
                            </div>
                        </div>
                    </div>
                    <div class="alliance_bottom_right">
                        <div class="alliance_bottom_right_box">
                            <div class="alliance_bottom_right_item"
                            :class="allianceIndex==index?'alliance_bottom_right_item_active':''"
                             v-for="(item,index) in alliance" :key="index"
                             @mouseenter="handleMouseAllianceEnter(index)"
                             @click="handleAlliance(item)">
                                <div class="alliance_bottom_right_item_box">
                                    <div class="alliance_bottom_right_item_img_name">
                                        <div class="alliance_bottom_right_item_img_name_left">
                                            <img src="../assets/images/index/alliance_item.png" alt="">
                                        </div>
                                        <div class="alliance_bottom_right_item_img_name_right">{{item.title}}</div>
                                    </div>
                                    <div class="alliance_bottom_right_item_img_time">{{item.publishTime?handleTime(item.publishTime):''}}</div>
                                </div>
                                <div class="alliance_bottom_right_item_box_line"></div>
                                <div class="alliance_bottom_right_item_box_active" v-if="allianceIndex==index">
                                    <img src="../assets/images/index/alliance_item_active.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="alliance_button" v-if="alliance.length>0">
                    <div class="alliance_button_item" @click="handleViewMore('/news',allianceTypeId)">查看更多</div>
                </div>
                <div class="alliance_bottom_none" v-if="alliance.length==0">暂无数据</div>
            </div>
        </div>
        <!-- 行业新闻，通知公告 -->
        <div class="news">
            <div class="news_box section">
                <div class="news_left">
                    <div class="news_left_top">
                        <div class="news_left_top_left">行业新闻</div>
                        <div class="news_left_top_right">
                            <div class="news_left_top_right_line"></div>
                            <div class="news_left_top_right_text" @click="handleViewMore('/news',industryTypeId)">查看更多</div>
                            <div class="news_left_top_right_img">
                                <img src="../assets/images/index/arrow_right.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="news_left_bottom">
                        <div class="news_left_bottom_box" v-if="industry.length>0">
                            <div class="news_left_bottom_item" 
                            @mouseenter="handleMouseIndustryEnter(index)" 
                            @click="handleIndustry(item)" v-for="(item,index) in industry" :key="index">
                                <div class="news_left_bottom_item_active" v-if="industryIndex==index">
                                    <div class="news_left_bottom_item_active_left">
                                        <img v-if="industry[industryIndex]&&industry[industryIndex].picture" :src="baseUrl+industry[industryIndex].picture" alt="">
                                        <img class="none_img" v-else src="../assets/images/index/img_none.png" alt="">
                                    </div>
                                    <div class="news_left_bottom_item_active_right">
                                        <div class="news_left_bottom_item_active_right_top">{{item.title}}</div>
                                        <div class="news_left_bottom_item_active_right_time">
                                            <div class="news_left_bottom_item_active_right_time_img">
                                                <img src="../assets/images/index/time.png" alt="">
                                            </div>
                                            <div class="news_left_bottom_item_active_right_time_time">{{item.publishTime?handleTime(item.publishTime):''}}</div>
                                        </div>
                                        <div class="news_left_bottom_item_active_right_profile">{{industry[industryIndex].profile}}</div>
                                    </div>
                                </div>
                                <div class="news_left_bottom_item_box" v-else>
                                    <div class="news_left_bottom_item_box_left">
                                        <div class="news_left_bottom_item_box_left_img"></div>
                                        <div class="news_left_bottom_item_box_left_name">{{item.title}}</div>
                                    </div>
                                    <div class="news_left_bottom_item_box_right">{{item.publishTime?handleTime(item.publishTime):''}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="news_left_bottom_box_none" v-if="industry.length==0">暂无数据</div>
                    </div>
                </div>
                <div class="news_right">
                    <div class="news_left_top">
                        <div class="news_left_top_left">通知公告</div>
                        <div class="news_left_top_right">
                            <div class="news_left_top_right_line"></div>
                            <div class="news_left_top_right_text" @click="handleViewMore('/news',noticeTypeId)">查看更多</div>
                            <div class="news_left_top_right_img">
                                <img src="../assets/images/index/arrow_right.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="news_right_bottom">
                        <div class="news_right_bottom_box" v-if="notice.length>0">
                            <div class="news_right_bottom_item" @click="handleNotice(item)" v-for="(item,index) in notice" :key="index">
                                <div class="news_right_bottom_item_name">{{item.title}}</div>
                                <div class="news_right_bottom_item_time">{{item.publishTime?handleTime(item.publishTime):''}}</div>
                            </div>
                        </div>
                        <div class="news_right_bottom_box_none" v-if="notice.length==0">暂无数据</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 党建工作 -->
        <div class="work">
            <div class="work_box section">
                <div class="work_top">
                    <div class="common_title">
                        <div class="common_title_top">
                            <div class="common_title_top_left"></div>
                            <div class="common_title_top_middle">党建工作</div>
                            <div class="common_title_top_right"></div>
                        </div>
                        <div class="common_title_bottom">PARTY BUILDING WORK</div>
                    </div>
                </div>
                <div class="work_bottom">
                    <div class="work_bottom_box" v-if="work.length>0">
                        <div class="work_bottom_item" @click="handleWork(item)" v-for="(item,index) in work" :key="index">
                            <div class="work_bottom_item_left">
                                <div class="work_bottom_item_left_img">
                                    <img src="../assets/images/index/alliance_item.png" alt="">
                                </div>
                                <div class="work_bottom_item_left_name">{{item.title}}</div>
                            </div>
                            <div class="work_bottom_item_right">{{item.publishTime?handleTime(item.publishTime):''}}</div>
                        </div>
                    </div>
                    <div class="work_bottom_box_none" v-if="work.length==0">暂无数据</div>
                    <div class="work_bottom_button" v-if="work.length>0">
                        <div class="work_bottom_button_item" @click="handleViewMoreMork">查看更多</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 品牌活动 -->
        <div class="brand">
            <div class="brand_box section">
                <div class="brand_top">
                    <div class="common_title">
                        <div class="common_title_top">
                            <div class="common_title_top_left"></div>
                            <div class="common_title_top_middle">品牌活动</div>
                            <div class="common_title_top_right"></div>
                        </div>
                        <div class="common_title_bottom">BRAND EVENT</div>
                    </div>
                </div>
                <div class="brand_bottom" v-if="brand.length>0">
                    <div class="brand_card" v-for="item in brand" :key="item.id" >
                        <!-- 3D翻转容器 -->
                        <div class="card_inner">
                            <!-- 正面：图片 -->
                            <div class="card_front">
                                <div class="card_front_img">
                                    <img v-if="item&&item.picture" :src="baseUrl+item.picture" alt="">
                                    <img class="none_img" v-else src="../assets/images/index/img_none.png" alt="">
                                </div>
                                <div class="brand_title">{{ item.typeName }}</div>
                            </div>
                            <!-- 背面：文字描述 -->
                            <div class="card_back" @click="goBrand(item)">
                                <div class="brand_title">{{ item.typeName }}</div>
                                <div class="brand_line"></div>
                                <div class="brand_profile">{{ item.profile }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="brand_bottom_none" v-if="brand.length==0">暂无数据</div>
            </div>
        </div>
        <!-- 联盟出版书籍 -->
        <div class="books">
            <div class="books_box section">
                <div class="books_top">
                    <div class="common_title">
                        <div class="common_title_top">
                            <div class="common_title_top_left"></div>
                            <div class="common_title_top_middle">联盟出版书籍</div>
                            <div class="common_title_top_right"></div>
                        </div>
                        <div class="common_title_bottom">THE ALLIANCE PUBLISHES BOOKS</div>
                    </div>
                </div>
                <div class="books_bottom">
                    <div class="books_bottom_box" v-if="books.length>0">
                        <div class="books_bottom_item" v-for="(item,index) in books" :key="index">
                            <div class="books_bottom_item_left">
                                <img v-if="item&&item.picture" :src="baseUrl+item.picture" alt="">
                                <img class="none_img" v-else src="../assets/images/index/img_none.png" alt="">
                            </div>
                            <div class="books_bottom_item_right">
                                <div class="books_bottom_item_right_top">{{item.title}}</div>
                                <div class="books_bottom_item_right_middle">{{item.profile}}</div>
                                <div class="books_bottom_item_right_bottom" @click="handleBooks(item)">
                                    <img src="../assets/images/index/book_more.png" alt="">
                                    阅读详情
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="books_bottom_box_none" v-if="books.length==0">暂无数据</div>
                </div>
                <div class="books_button" v-if="books.length>0">
                    <div class="books_button_item" @click="goBooks">查看更多</div>
                </div>
            </div>
        </div>
        <!-- 你问我答 -->
        <div class="answer">
            <div class="answer_box section">
                <div class="answer_left">
                    <div class="answer_left_top">
                        <div class="answer_left_top_left">
                            <img src="../assets/images/index/answer_1.png" alt="">
                        </div>
                        <div class="answer_left_top_right">
                            <div class="answer_left_top_right_top">你问我答</div>
                            <div class="answer_left_top_right_bottom">你提出诉求，我给予解答</div>
                        </div>
                    </div>
                    <div class="answer_left_bottom">
                        <div class="answer_left_bottom_item" @click="goAnswer">查看更多</div>
                    </div>
                </div>
                <div class="answer_right">
                    <div class="answer_right_box" v-if="answer.length>0">
                        <div class="answer_right_box_box">
                            <div class="answer_right_item" @click="handleMoreAnswer(item)" v-for="(item,index) in answer" :key="index">
                                <div class="answer_right_item_left">
                                    <img src="../assets/images/index/alliance_item.png" alt="">
                                </div>
                                <div class="answer_right_item_right">{{item.question}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="answer_right_box_none" v-if="answer.length==0">暂无数据</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { newsTypeList,newsList,questionPage } from '../untils/common-api.js'
export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_URL,
            typeList: [2, 1, 4, 15, 11, 12],
            /**
             * 联盟动态
             * 行业新闻
             * 通知公告
             * 图片新闻
             */
            alliance: [],
            allianceTypeId:null,
            allianceIndex:0,
            industry: [],
            industryTypeId:null,
            industryIndex:0,
            notice: [],
            noticeTypeId:null,
            // 党建工作  id:29
            work:[],
            // 品牌活动分类
            brand:[],
            // 联盟出版书籍
            books:[],
            // 你问我答
            answer:[],
        }
    },
    methods:{
        // 获取新闻分类
        async getNewsTypeList(num) {
            const res = await newsTypeList(
                {
                    model:num,
                    lang:1
                }
            )
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            let list = res.data.records
            if(list.length>0) {
                list.forEach(item => {
                    if(item.typeName=='联盟动态') {
                        this.getAlliance(item.id)
                        this.allianceTypeId = item.id
                    } else if(item.typeName=='行业新闻') {
                        this.getIndustry(item.id)
                        this.industryTypeId = item.id
                    } else if(item.typeName=='通知公告') {
                        this.getNotice(item.id)
                        this.noticeTypeId = item.id
                    }
                });
            }
        },
        // 联盟动态
        async getAlliance(id) {
            const res = await newsList(
                {
                    current:1,
                    pageSize:6,
                    model:2,
                    newsType:id,
                    lang:1
                }
            )
            if(res.code==1) {
                this.alliance = res.data.records
            }
        },
        handleAlliance(item) {
            if(item.link) {
                if(item) {
                    // 打开新页面
                    window.open(item.link, '_blank');
                }
            } else {
                this.$router.push({name: 'details', params: { name: 'news', type: item.newsType, id: item.id,current:1 } })
            }
        },
        handleMouseAllianceEnter(index) {
            this.allianceIndex = index
        },
        handleTime(time) {
            if(time) {
                let year = time.substring(0,4);
                let month = time.substring(5,7);
                let day = time.substring(8,10);
                let timeStr = year+'-'+month+'-'+day
                return timeStr;
            }
        },
        // 行业新闻
        async getIndustry(id) {
            const res = await newsList(
                {
                    current:1,
                    pageSize:6,
                    model:2,
                    newsType:id,
                    lang:1
                }
            )
            if(res.code==1) {
                this.industry = res.data.records
            }
        },
        handleIndustry(item) {
            if(item.link) {
                if(item) {
                    // 打开新页面
                    window.open(item.link, '_blank');
                }
            } else {
                this.$router.push({name: 'details', params: { name: 'news', type: item.newsType, id: item.id,current:1 } })
            }
        },
        handleMouseIndustryEnter(index) {
            this.industryIndex = index
        },
        // 通知公告
        async getNotice(id) {
            const res = await newsList(
                {
                    current:1,
                    pageSize:5,
                    model:2,
                    newsType:id,
                    lang:1
                }
            )
            if(res.code==1) {
                this.notice = res.data.records
            }
        },
        handleNotice(item) {
            if(item.link) {
                if(item) {
                    // 打开新页面
                    window.open(item.link, '_blank');
                }
            } else {
                this.$router.push({name: 'details', params: { name: 'news', type: item.newsType, id: item.id,current:1 } })
            }
        },
        handleViewMore(path,type) {
            this.$router.push(
                {
                    path,
                    query: {
                        type
                    }
                }
            )
        },
        // 党建工作
        async getWork() {
            const res = await newsList(
                {
                    current:1,
                    pageSize:5,
                    model:3,
                    lang:1
                }
            )
            if(res.code==1) {
                this.work = res.data.records
            }
        },
        handleWork(item) {
            if(item.link) {
                if(item) {
                    // 打开新页面
                    window.open(item.link, '_blank');
                }
            } else {
                this.$router.push({name: 'specifics', params: { name: 'work', type: item.newsType, id: item.id,current:1 } })
            }
        },
        handleViewMoreMork() {
            this.$router.push('/work')
        },
        // 品牌活动分类
        async getBrandTypeList(num) {
            const res = await newsTypeList (
                {
                    model:num,
                    lang:1
                }
            )
            if(res.code==1) {
                this.brand = res.data.records
            }
        },
        goBrand(item) {
            this.$router.push(
                {
                    path:'/brand',
                    query:{
                        type:item.id
                    }
                }
            )
        },
        // 联盟出版书籍
        async getBooks() {
            const res = await newsList(
                {
                    current:1,
                    pageSize:4,
                    model:5,
                    lang:1
                }
            )
            if(res.code==1) {
                this.books = res.data.records
            }
        },
        handleBooks(item) {
            if(item.link) {
                if(item) {
                    // 打开新页面
                    window.open(item.link, '_blank');
                }
            } else {
                this.$router.push({name: 'specifics', params: { name: 'books', type: item.newsType, id: item.id,current:1 } })
            }
        },
        goBooks() {
            this.$router.push(
                {
                    path:'/books',
                }
            )
        },
        // 你问我答
        async getAnswer() {
            const res = await questionPage(
                {
                    current:1,
                    pageSize:5,
                    lang:1
                }
            )
            if(res.code==1) {
                this.answer = res.data.records
            }
        },
        goAnswer() {
            this.$router.push(
                {
                    path:'/answer',
                }
            )
        },
        handleMoreAnswer(item) {
            this.$router.push(
                {
                    path:'/answer',
                    query:{
                        id:item.id
                    }
                }
            )

        }
    },
    beforeRouteLeave(to, from, next) {
        if(to.name == "details") {
            window.sessionStorage.setItem('scrollPosition', -1);
        }
        next();
    },
    created() {
        // 获取新闻分类
        this.getNewsTypeList(2)
        this.getWork()
        // 获取品牌活动分类
        this.getBrandTypeList(4)
        this.getBooks()
        this.getAnswer()
    },
}
</script>
<style lang="less" scoped>
.index {
    .alliance {
        background: url('../assets/images/index/alliance_bgc.png') no-repeat center center;
        padding-bottom: 80px;
        .alliance_box {
            .alliance_top {
                padding: 80px 0 55px 0;
            }
            .alliance_bottom {
                display: flex;
                justify-content: space-between;
                .alliance_bottom_left {
                    width: 580px;
                    border-radius: 10px;
                    overflow: hidden;
                    cursor: pointer;
                    .alliance_bottom_left_img{
                        width: 100%;
                        height: 386px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                        .none_img {
                            max-width: 100%;
                            max-height: 100%;
                            object-fit: contain;
                        }
                    }
                    .alliance_bottom_left_profile {
                        background-color: #ffffff;
                        padding: 20px;
                        .alliance_bottom_left_profile_text {
                            font-size: 18px;
                            line-height: 1.8;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            height: 65px;
                        }
                    }
                }
                .alliance_bottom_right {
                    .alliance_bottom_right_box {
                        .alliance_bottom_right_item {
                            width: 580px;
                            padding: 6px 0;
                            position: relative;
                            cursor: pointer;
                            .alliance_bottom_right_item_box {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                padding: 0 20px;
                                height: 70px;
                                .alliance_bottom_right_item_img_name {
                                    font-size: 18px;
                                    width: calc(100% - 100px - 50px);
                                    display: flex;
                                    align-items: center;
                                    .alliance_bottom_right_item_img_name_left {
                                        margin-right: 20px;
                                        img {
                                            width: 10px;
                                            height: 10px;
                                        }
                                    }
                                    .alliance_bottom_right_item_img_name_right {
                                        width: calc(100% - 10px - 20px);
                                        display: -webkit-box;
                                        -webkit-line-clamp: 1;
                                        -webkit-box-orient: vertical;
                                        overflow: hidden;
                                    }
                                }
                                .alliance_bottom_right_item_img_time {
                                    width: 100px;
                                    font-size: 16px;
                                    color: #787878;
                                }
                                
                            }
                            .alliance_bottom_right_item_box_line {
                                position: absolute;
                                left: 50%;
                                bottom: 0;
                                transform: translateX(-50%);
                                width: 543px;
                                border-bottom: 1px dashed #E1E1E1;
                            }
                            .alliance_bottom_right_item_box_active {
                                position: absolute;
                                left: -15px;
                                top: 50%;
                                transform: translateY(-50%);
                                width: 25px;
                                height: 25px;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                        }
                        .alliance_bottom_right_item_active {
                            .alliance_bottom_right_item_box {
                                background-color: #ffffff;
                                border-radius: 6px;
                            }
                        }
                    }
                }
            }
            .alliance_button {
                margin: 40px 0 0 0;
                display: flex;
                justify-content: center;
                .alliance_button_item {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 248px;
                    height: 48px;
                    border-radius: 12px;
                    background-color: #0085D0;
                    cursor: pointer;
                    color: #ffffff;
                    font-size: 18px;
                }
            }
            .alliance_bottom_none {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 16px;
            }
        }
    }
    .news {
        background-color: #f6f6f6;
        padding: 80px 0;
        .news_box {
            display: flex;
            justify-content: space-between;
            >div {
                background-color: #ffffff;
                border-radius: 12px;
            }
            .news_left {
                width: 780px;
                padding: 30px;
                .news_left_top {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 1px solid #ECECEC;
                    padding-bottom: 20px;
                    .news_left_top_left {
                        color: #000000;
                        font-size: 32px;
                        font-weight: bold;
                    }
                    .news_left_top_right {
                        display: flex;
                        align-items: center;
                        .news_left_top_right_line {
                            width: 34px;
                            height: 2px;
                            background-color: #0085D0;
                        }
                        .news_left_top_right_text {
                            font-size: 16px;
                            color: #787878;
                            margin: 0 10px;
                            cursor: pointer;
                        }
                        .news_left_top_right_img {
                            img {
                                width: 7px;
                                height: 12px;
                            }
                        }
                    }
                }
                .news_left_bottom {
                    .news_left_bottom_box {
                        padding-top: 25px;
                        .news_left_bottom_item {
                            margin-bottom: 25px;
                            cursor: pointer;
                            .news_left_bottom_item_active {
                                display: flex;
                                justify-content: space-between;
                                padding-bottom: 25px;
                                border-bottom: 1px solid #ECECEC;
                                .news_left_bottom_item_active_left {
                                    width:240px ;
                                    height: 160px;
                                    overflow: hidden;
                                    border-radius: 6px;
                                    margin-right: 25px;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    img {
                                        width: 100%;
                                        height: 100%;
                                    }
                                    .none_img {
                                        max-width: 100%;
                                        max-height: 100%;
                                        object-fit: contain;
                                    }
                                }
                                .news_left_bottom_item_active_right {
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                    padding: 10px 0;
                                    width: calc(100% - 240px - 25px);
                                    .news_left_bottom_item_active_right_top {
                                        font-size: 20px;
                                        color: #000000;
                                        font-weight: bold;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 1;
                                        -webkit-box-orient: vertical;
                                        overflow: hidden;
                                    }
                                    .news_left_bottom_item_active_right_time {
                                        display: flex;
                                        align-items: center;
                                        .news_left_bottom_item_active_right_time_img {
                                            margin-right: 10px;
                                            img {
                                                width: 18px;
                                                height: 18px;
                                            }
                                        }
                                        .news_left_bottom_item_active_right_time_time {
                                            font-size: 16px;
                                            color: #000000;
                                        }
                                    }
                                    .news_left_bottom_item_active_right_profile {
                                        font-size: 16px;
                                        color: #787878;
                                        line-height: 2;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 2;
                                        -webkit-box-orient: vertical;
                                        overflow: hidden;
                                    }
                                }
                            }
                            .news_left_bottom_item_box {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                .news_left_bottom_item_box_left {
                                    width: calc(100% - 120px - 20px);
                                    display: flex;
                                    align-items: center;
                                    .news_left_bottom_item_box_left_img {
                                        background-color: #39A516;
                                        width: 5px;
                                        height: 5px;
                                        border-radius: 100%;
                                        margin-right: 5px;
                                    }
                                    .news_left_bottom_item_box_left_name{
                                        width: calc(100% - 10px);
                                        font-size: 18px;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 1;
                                        -webkit-box-orient: vertical;
                                        overflow: hidden;
                                    }
                                }
                                .news_left_bottom_item_box_right {
                                    font-size: 18px;
                                    color: #787878;
                                    width: 120px;
                                    text-align: right;
                                }
                            }
                        }
                        .news_left_bottom_item:last-child {
                            margin-bottom: 0;
                        }
                    }
                    .news_left_bottom_box_none {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 16px;
                        min-height: 200px;
                    }
                }
            }
            .news_right {
                width: 390px;
                padding: 30px;
                .news_left_top {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 1px solid #ECECEC;
                    padding-bottom: 20px;
                    .news_left_top_left {
                        color: #000000;
                        font-size: 32px;
                        font-weight: bold;
                    }
                    .news_left_top_right {
                        display: flex;
                        align-items: center;
                        .news_left_top_right_line {
                            width: 34px;
                            height: 2px;
                            background-color: #0085D0;
                        }
                        .news_left_top_right_text {
                            font-size: 16px;
                            color: #787878;
                            margin: 0 10px;
                            cursor: pointer;
                        }
                        .news_left_top_right_img {
                            img {
                                width: 7px;
                                height: 12px;
                            }
                        }
                    }
                }
                .news_right_bottom {
                    .news_right_bottom_box {
                        .news_right_bottom_item {
                            cursor: pointer;
                            border-bottom: 1px solid #ECECEC;
                            padding: 18px 0;
                            .news_right_bottom_item_name {
                                font-size: 18px;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                margin-bottom: 8px;
                            }
                            .news_right_bottom_item_time{
                                font-size: 16px;
                                color: #787878;
                            }
                        }
                        .news_right_bottom_item:last-child {
                            border: none;
                        }
                        .news_right_bottom_item:hover {
                            text-decoration: underline;
                            text-decoration-color: #0085D0;
                            .news_right_bottom_item_name {
                                color: #0085D0;
                            }
                            .news_right_bottom_item_time{
                                color: #0085D0;
                            }
                        }
                    }
                    .news_right_bottom_box_none {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 16px;
                        min-height: 200px;
                    }
                }
            }
        }
    }
    .work {
        background: url('../assets/images/index/work_bgc.png') no-repeat center center;
        padding: 80px 0;
        .work_box {
            .work_top {
                padding-bottom: 55px;
            }
            .work_bottom {
                .work_bottom_box {
                    display: flex;
                    flex-wrap: wrap;
                    .work_bottom_item {
                        width: 48%;
                        margin-right: 4%;
                        display: flex;
                        align-items: center;
                        margin-bottom:30px;
                        cursor: pointer;
                        .work_bottom_item_left {
                            display: flex;
                            align-items: center;
                            width: calc(100% - 100px);
                            .work_bottom_item_left_img {
                                margin-right: 20px;
                                img {
                                    width: 10px;
                                    height: 10px;
                                }
                            }
                            .work_bottom_item_left_name {
                                font-size: 18px;
                                width: calc(100% - 10px - 20px - 20px);
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                            }
                        }
                        .work_bottom_item_right {
                            text-align: right;
                            font-size: 16px;
                            color: #787878;
                            width: 100px;
                        }
                    }
                    .work_bottom_item:nth-child(2n) {
                        margin-right: 0;
                    }
                }
                .work_bottom_box_none {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 16px;
                    // min-height: 200px;
                }
                .work_bottom_button {
                    margin: 40px 0 0 0;
                    display: flex;
                    justify-content: center;
                    .work_bottom_button_item {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 248px;
                        height: 48px;
                        border-radius: 12px;
                        background-color: #ffffff;
                        cursor: pointer;
                        color: #DD3A3A;
                        font-size: 18px;
                    }
                }
            }
        }
    }
    .brand {
        background: url('../assets/images/index/brand_bgc.png') no-repeat center center;
        padding: 80px 0;
        .brand_box {
            .brand_top {
                padding: 0 0 55px 0;
            }
            .brand_bottom {
                display: flex;
                flex-wrap: wrap;
                gap: 28px;
                justify-content: center;
                .brand_card {
                    width: 278px;
                    height: 278px;
                    perspective: 1000px; /* 创建3D透视效果 */
                    cursor: pointer;
                    .card_inner {
                        position: relative;
                        width: 100%;
                        height: 100%;
                        transition: transform 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                        transform-style: preserve-3d; /* 保持3D变换 */
                        border-radius: 10px;
                        >div {
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            backface-visibility: hidden; /* 隐藏背面 */
                            border-radius: 10px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            padding: 30px;
                            box-sizing: border-box;
                            overflow: hidden;
                        }
                        .card_front {
                            background: url('../assets/images/index/brand_front_bgc.png') no-repeat center center;
                            // border: 1px solid rgba(235,235,235,0.2);
                            .card_front_img {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                img {
                                    width: 85px;
                                    height: 85px;
                                    object-fit: contain;
                                    margin-bottom: 30px;
                                    transition: transform 0.3s ease;
                                }
                                .none_img {
                                    max-width: 100%;
                                    max-height: 100%;
                                    object-fit: contain;
                                }
                            }
                            .brand_title {
                                font-size: 20px;
                                font-weight: bold;
                                margin-bottom: 15px;
                                text-align: center;
                            }
                        }
                        .card_back {
                            background: url('../assets/images/index/brand_back_bgc.png') no-repeat center center;
                            color: white;
                            transform: rotateY(180deg); /* 初始时背面翻转180度隐藏 */
                            text-align: center;
                            overflow-y: auto;
                            .brand_title{
                                font-size: 20px;
                                font-weight: bold;
                                text-align: center;
                            }
                            .brand_line {
                                width: 48px;
                                height: 4px;
                                background-color: #ffffff;
                                border-radius: 2px;
                                margin: 15px 0;
                            }
                            .brand_profile {
                                font-size: 14px;
                                line-height:2;
                                text-align: justify;
                            }
                        }
                    }
                }
                /* CSS hover 实现翻转 */
                .brand_card:hover .card_inner {
                    transform: rotateY(180deg);
                }
            }
            .brand_bottom_none {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 16px;
            }
        }
    }
    .books {
        padding: 80px 0;
        .books_box {
            .books_top {
                padding: 0 0 55px 0;
            }
            .books_bottom {
                .books_bottom_box {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 30px;
                    .books_bottom_item {
                        width: 585px;
                        height: 220px;
                        background: #ffffff;
                        border: 1px solid #eeeeee;
                        border-radius: 12px;
                        padding: 20px;
                        display: flex;
                        justify-content: space-between;
                        .books_bottom_item_left {
                            width: 180px;
                            height: 180px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                            .none_img {
                                max-width: 100%;
                                max-height: 100%;
                                object-fit: contain;
                            }
                        }
                        .books_bottom_item_right {
                            width: calc(100% - 180px - 30px);
                            padding: 10px 0;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            .books_bottom_item_right_top {
                                font-size: 20px;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                            }
                            .books_bottom_item_right_middle{
                                font-size: 14px;
                                color: #787878;
                                line-height: 2;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                            }
                            .books_bottom_item_right_bottom {
                                display: flex;
                                flex-direction: row-reverse;
                                font-size: 14px;
                                align-items: center;
                                color: #0085D0;
                                cursor: pointer;
                                img {
                                    width: 10px;
                                    height: 10px;
                                    margin-left:5px ;
                                }
                            }
                        }
                    }
                }
                .books_bottom_box_none {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 16px;
                }
            }
            .books_button {
                margin: 60px 0 0 0;
                display: flex;
                justify-content: center;
                .books_button_item {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 248px;
                    height: 48px;
                    border-radius: 12px;
                    background-color: #0085D0;
                    cursor: pointer;
                    color: #ffffff;
                    font-size: 18px;
                }
            }
        }
    }
    .answer {
        background: url('../assets/images/index/answer_bgc.png') no-repeat center center;
        padding: 50px 0;
        .answer_box {
            display: flex;
            // justify-content: space-between;
            .answer_left {
                width: 400px;
                display: flex;
                align-items: center;
                flex-direction: column;
                margin-right: 100px;
                .answer_left_top {
                    display: flex;
                    align-items: center;
                    .answer_left_top_left {
                        width: 106px;
                        height: 100px;
                        margin-right: 20px;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .answer_left_top_right {
                        .answer_left_top_right_top {
                            font-size: 38px;
                            color: #ffffff;
                            font-weight: bold;
                            margin-bottom: 10px;
                        }
                        .answer_left_top_right_bottom {
                            font-size: 20px;
                            color: #ffffff;
                        }
                    }
                }
                .answer_left_bottom {
                    margin-top: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 152px;
                    height: 48px;
                    border-radius: 12px;
                    background-color: #ffffff;
                    cursor: pointer;
                    color: #0085D0;
                    font-size: 18px;
                    margin-left: 55px;
                }
            }
            .answer_right {
                width: calc(100% - 400px - 100px);
                .answer_right_box {
                    display: flex;
                    // flex-direction: row-reverse;
                    .answer_right_box_box {
                        .answer_right_item {
                            display: flex;
                            align-items: center;
                            margin-bottom: 20px;
                            cursor: pointer;
                            .answer_right_item_left {
                                margin-right: 20px;
                                img {
                                    width: 10px;
                                    height: 10px;
                                }
                            }
                            .answer_right_item_right {
                                width: calc(100% - 20px - 10px);
                                font-size: 18px;
                                color: #ffffff;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                            }
                        }
                        .answer_right_item:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
                .answer_right_box_none {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 16px;
                    color: #ffffff;
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .index {
        .alliance {
            padding-bottom: 0.8rem;
            .alliance_box {
                .alliance_top {
                    padding: 0.8rem 0 0.55rem 0;
                }
                .alliance_bottom {
                    flex-direction: column;
                    .alliance_bottom_left {
                        width: 100%;
                        border-radius: 0.15rem;
                        overflow: hidden;
                        margin-bottom: 0.2rem;
                        .alliance_bottom_left_img{
                            width: 100%;
                            height: 4.7rem;
                        }
                        .alliance_bottom_left_profile {
                            padding: 0.2rem;
                            .alliance_bottom_left_profile_text {
                                font-size: 0.28rem;
                                line-height: 1.6;
                                height: auto;
                            }
                        }
                    }
                    .alliance_bottom_right {
                        width: 100%;
                        .alliance_bottom_right_box {
                            width: 100%;
                            .alliance_bottom_right_item {
                                width: 100%;
                                padding: 0.1rem 0;
                                .alliance_bottom_right_item_box {
                                    padding: 0 .2rem;
                                    height: 1rem;
                                    .alliance_bottom_right_item_img_name {
                                        width: calc(100% - 1.7rem - 0.3rem);
                                        .alliance_bottom_right_item_img_name_left {
                                            margin-right: .2rem;
                                            img {
                                                width: 0.2rem;
                                                height: 0.2rem;
                                            }
                                        }
                                        .alliance_bottom_right_item_img_name_right {
                                            font-size: 0.3rem;
                                            width: calc(100% - 0.2rem - 0.2rem);
                                        }
                                    }
                                    .alliance_bottom_right_item_img_time {
                                        width: 1.7rem;
                                        font-size: 0.26rem;
                                    }
                                }
                                .alliance_bottom_right_item_box_line {
                                    width: 100%;
                                }
                                .alliance_bottom_right_item_box_active {
                                    left: 0;
                                    transform: translate(-60%,-50%);
                                    width: 0.4rem;
                                    height: 0.4rem;
                                }
                            }
                            .alliance_bottom_right_item_active {
                                .alliance_bottom_right_item_box {
                                    border-radius: 0.1rem;
                                }
                            }
                        }
                    }
                }
                .alliance_button {
                    margin: 0.4rem 0 0 0;
                    .alliance_button_item {
                        width: 3.5rem;
                        height: 0.75rem;
                        border-radius: 0.15rem;
                        font-size: 0.3rem;
                    }
                }
                .alliance_bottom_none {
                    font-size: 0.3rem;
                    padding-bottom: 1rem;
                }
            }
        }
        .news {
            padding: 0.8rem 0;
            .news_box {
                flex-direction: column;
                >div {
                    border-radius: 0.15rem;
                }
                .news_left {
                    width: 100%;
                    padding: 0.3rem;
                    margin-bottom: 0.3rem;
                    .news_left_top {
                        padding-bottom: 0.3rem;
                        .news_left_top_left {
                            font-size: 0.4rem;
                        }
                        .news_left_top_right {
                            .news_left_top_right_line {
                                width: 0.6rem;
                                height: 0.04rem;
                            }
                            .news_left_top_right_text {
                                font-size: 0.3rem;
                                margin: 0 0.15rem;
                            }
                            .news_left_top_right_img {
                                img {
                                    width: 0.12rem;
                                    height: 0.2rem;
                                }
                            }
                        }
                    }
                    .news_left_bottom {
                        .news_left_bottom_box {
                            padding-top: 0.25rem;
                            .news_left_bottom_item {
                                margin-bottom: 0.25rem;
                                .news_left_bottom_item_active {
                                    padding-bottom: 0.25rem;
                                    .news_left_bottom_item_active_left {
                                        width:2.5rem ;
                                        height: 1.5rem;
                                        border-radius: 0.1rem;
                                        margin-right: 0.3rem;
                                        img {
                                            width: 100%;
                                            height: 100%;
                                        }
                                        .none_img {
                                            max-width: 100%;
                                            max-height: 100%;
                                            object-fit: contain;
                                        }
                                    }
                                    .news_left_bottom_item_active_right {
                                        padding: 0.1rem 0;
                                        width: calc(100% - 2.5rem - 0.2rem);
                                        .news_left_bottom_item_active_right_top {
                                            font-size: 0.3rem;
                                        }
                                        .news_left_bottom_item_active_right_time {
                                            .news_left_bottom_item_active_right_time_img {
                                                margin-right: 0.1rem;
                                                img {
                                                    width: 0.25rem;
                                                    height: 0.25rem;
                                                }
                                            }
                                            .news_left_bottom_item_active_right_time_time {
                                                font-size: 0.26rem;
                                            }
                                        }
                                        .news_left_bottom_item_active_right_profile {
                                            font-size: 0.28rem;
                                            line-height: 1.6;
                                            display: -webkit-box;
                                            -webkit-line-clamp: 1;
                                            -webkit-box-orient: vertical;
                                            overflow: hidden;
                                        }
                                    }
                                }
                                .news_left_bottom_item_box {
                                    .news_left_bottom_item_box_left {
                                        width: calc(100% - 1.6rem - 0.4rem);
                                        .news_left_bottom_item_box_left_img {
                                            width: 0.1rem;
                                            height: 0.1rem;
                                            margin-right: 0.1rem;
                                        }
                                        .news_left_bottom_item_box_left_name{
                                            width: calc(100% - 0.15rem);
                                            font-size: 0.3rem;
                                        }
                                    }
                                    .news_left_bottom_item_box_right {
                                        font-size: 0.26rem;
                                        width: 1.6rem;
                                    }
                                }
                            }
                        }
                        .news_left_bottom_box_none {
                            font-size: 0.3rem;
                            min-height: 3rem;
                        }
                    }
                }
                .news_right {
                    width: 100%;
                    padding: 0.3rem;
                    .news_left_top {
                        padding-bottom: 0.3rem;
                        .news_left_top_left {
                            font-size: 0.4rem;
                        }
                        .news_left_top_right {
                            display: flex;
                            align-items: center;
                            .news_left_top_right_line {
                                width: 0.6rem;
                                height: 0.04rem;
                            }
                            .news_left_top_right_text {
                                font-size: 0.3rem;
                                margin: 0 0.15rem;
                            }
                            .news_left_top_right_img {
                                img {
                                    width: 0.12rem;
                                    height: 0.2rem;
                                }
                            }
                        }
                    }
                    .news_right_bottom {
                        .news_right_bottom_box {
                            .news_right_bottom_item {
                                padding: 0.2rem 0;
                                .news_right_bottom_item_name {
                                    font-size: 0.3rem;
                                    margin-bottom: 0.1rem;
                                }
                                .news_right_bottom_item_time{
                                    font-size: 0.26rem;
                                }
                            }
                        }
                        .news_right_bottom_box_none {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.3rem;
                            min-height: 3rem;
                        }
                    }
                }
            }
        }
        .work {
            padding: 0.8rem 0;
            .work_box {
                .work_top {
                    padding-bottom: 0.6rem;
                }
                .work_bottom {
                    .work_bottom_box {
                        .work_bottom_item {
                            width: 100%;
                            margin-right: 0;
                            margin-bottom:0.2rem;
                            .work_bottom_item_left {
                                width: calc(100% - 1.6rem);
                                .work_bottom_item_left_img {
                                    margin-right: 0.2rem;
                                    img {
                                        width: 0.2rem;
                                        height: 0.2rem;
                                    }
                                }
                                .work_bottom_item_left_name {
                                    font-size: 0.3rem;
                                    width: calc(100% - 0.2rem - 0.3rem);
                                }
                            }
                            .work_bottom_item_right {
                                font-size: 0.26rem;
                                width: 1.6rem;
                            }
                        }
                    }
                    .work_bottom_box_none {
                        font-size: 0.3rem;
                        // min-height: 200px;
                    }
                    .work_bottom_button {
                        margin: 0.4rem 0 0 0;
                        display: flex;
                        justify-content: center;
                        .work_bottom_button_item {
                            color: #DD3A3A;
                            height: 0.75rem;
                            border-radius: 0.15rem;
                            font-size: 0.3rem;
                        }
                    }
                }
            }
        }
        .brand {
            padding: 0.8rem 0;
            .brand_box {
                .brand_top {
                    padding: 0 0 0.6rem 0;
                }
                .brand_bottom {
                    gap: 0.2rem;
                    .brand_card {
                        width: 3.4rem;
                        height: 3.4rem;
                        .card_inner {
                            border-radius: 0.15rem;
                            >div {
                                border-radius: 0.15rem;
                                padding: 0.3rem;
                            }
                            .card_front {
                                background-size: 100% 100%;
                                // border: 1px solid rgba(235,235,235,0.2);
                                .card_front_img {
                                    img {
                                        width: 1.2rem;
                                        height: 1.2rem;
                                        margin-bottom: 0.2rem;
                                    }
                                }
                                .brand_title {
                                    font-size: 0.3rem;
                                    margin-bottom: 0.2rem;
                                }
                            }
                            .card_back {
                                background-size: 100% 100%;
                                .brand_title{
                                    font-size: 0.3rem;
                                }
                                .brand_line {
                                    width: 0.9rem;
                                    height: 0.06rem;
                                    border-radius: 2px;
                                    margin: 0.15rem 0;
                                }
                                .brand_profile {
                                    font-size: 0.26rem;
                                    line-height:1.6;
                                }
                            }
                        }
                    }
                }
                .brand_bottom_none {
                    font-size: 0.3rem;
                }
            }
        }
        .books {
            padding: 0.8rem 0;
            .books_box {
                .books_top {
                    padding: 0 0 0.6rem 0;
                }
                .books_bottom {
                    .books_bottom_box {
                        gap: 0.2rem 0;
                        .books_bottom_item {
                            width: 100%;
                            height: 2.7rem;
                            border-radius: 0.15rem;
                            padding: 0.2rem;
                            .books_bottom_item_left {
                                width: 2.3rem;
                                height: 2.3rem;
                            }
                            .books_bottom_item_right {
                                width: calc(100% - 2.3rem - 0.3rem);
                                padding: 0.2rem 0;
                                .books_bottom_item_right_top {
                                    font-size: 0.3rem;
                                }
                                .books_bottom_item_right_middle{
                                    font-size: 0.26rem;
                                    line-height: 1.6;
                                }
                                .books_bottom_item_right_bottom {
                                    font-size: 0.26rem;
                                    img {
                                        width: 0.15rem;
                                        height: 0.15rem;
                                        margin-left:0.1rem ;
                                    }
                                }
                            }
                        }
                    }
                    .books_bottom_box_none {
                        font-size: 0.3rem;
                    }
                }
                .books_button {
                    margin: 0.4rem 0 0 0;
                    .books_button_item {
                        width: 3.5rem;
                        height: 0.75rem;
                        border-radius: 0.15rem;
                        font-size: 0.3rem;
                    }
                }
            }
        }
        .answer {
            background-size: cover;
            padding: 0.8rem 0;
            .answer_box {
                flex-direction: column;
                .answer_left {
                    width: 100%;
                    margin-right: 0;
                    margin-bottom: .3rem;
                    .answer_left_top {
                        .answer_left_top_left {
                            width: 1.55rem;
                            height: 1.5rem;
                            margin-right: 0.2rem;
                        }
                        .answer_left_top_right {
                            .answer_left_top_right_top {
                                font-size: 0.4rem;
                                margin-bottom: 0.1rem;
                            }
                            .answer_left_top_right_bottom {
                                font-size: 0.3rem;
                            }
                        }
                    }
                    .answer_left_bottom {
                        margin-top: 0.15rem;
                        margin-left: 0.9rem;
                        width: 2.5rem;
                        height: 0.75rem;
                        border-radius: 0.15rem;
                        font-size: 0.3rem;
                    }
                }
                .answer_right {
                    width: 100%;
                    .answer_right_box {
                        .answer_right_box_box {
                            .answer_right_item {
                                margin-bottom: 0.2rem;
                                .answer_right_item_left {
                                    margin-right: 0.2rem;
                                    img {
                                        width: 0.2rem;
                                        height: 0.2rem;
                                    }
                                }
                                .answer_right_item_right {
                                    width: calc(100% - 0.2rem - 0.3rem);
                                    font-size: 0.3rem;
                                }
                            }
                            .answer_right_item:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                    .answer_right_box_none {
                        font-size: 0.3rem;
                    }
                }
            }
        }
    }
}
</style>